var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n        Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n        Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Waybill Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Waybill Charges (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.wayBillCharges),
      expression: "wayBillCharges"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Waybill Charges')
    },
    attrs: {
      "type": "number",
      "name": "Waybill Charges",
      "id": "wayBillCharges",
      "placeholder": "Waybill Charges"
    },
    domProps: {
      "value": (_vm.wayBillCharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wayBillCharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Waybill Charges')),
      expression: "errors.has('Waybill Charges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Waybill Charges')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "15px 0px 10px 0px"
    }
  }, [_vm._v("Per Waybill")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[15]),
      expression: "accordianTab[15]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck15"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[15]) ? _vm._i(_vm.accordianTab[15], null) > -1 : (_vm.accordianTab[15])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(15)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[15],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[15] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[15] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 15, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck15"
    }
  }, [_vm._v("DC Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("DC Charges (INR)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dccharges),
      expression: "dccharges"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('DC Charges')
    },
    attrs: {
      "type": "number",
      "name": "DC Charges",
      "id": "dccharges",
      "placeholder": "DC Charges"
    },
    domProps: {
      "value": (_vm.dccharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dccharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Waybill Charges')),
      expression: "errors.has('Waybill Charges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('DC Charges')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "15px 0px 10px 0px"
    }
  }, [_vm._v("Per Waybill")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("FTC (To Pay) Charges"), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "padding": "0px 70% 0px 0px"
    }
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chargePayType),
      expression: "chargePayType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Charge Pay Type",
      "value": "DOCKET"
    },
    domProps: {
      "checked": _vm._q(_vm.chargePayType, "DOCKET")
    },
    on: {
      "click": function($event) {
        _vm.showChargePayType()
      },
      "__c": function($event) {
        _vm.chargePayType = "DOCKET"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Per Docket")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Charge Pay Type')),
      expression: "errors.has('Charge Pay Type')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Charge Pay Type')))])]), _vm._v(" "), (_vm.showdocket == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', [_vm._v("(INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.payChargesInr),
      expression: "payChargesInr"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Pay Charge INR')
    },
    attrs: {
      "type": "number",
      "name": "Pay Charge INR",
      "id": "payChargesInr",
      "placeholder": "INR"
    },
    domProps: {
      "value": (_vm.payChargesInr)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payChargesInr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pay Charge INR')),
      expression: "errors.has('Pay Charge INR')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Per Docket Charge is required")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chargePayType),
      expression: "chargePayType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Charge Pay Type",
      "value": "PERCENT"
    },
    domProps: {
      "checked": _vm._q(_vm.chargePayType, "PERCENT")
    },
    on: {
      "click": function($event) {
        _vm.showChargePayType();
        _vm.minFodCharge = 0;
        _vm.maxFodCharge = 0;
      },
      "__c": function($event) {
        _vm.chargePayType = "PERCENT"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    },
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("% of freight charges")])])]), _vm._v(" "), (_vm.showpercent == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', [_vm._v("(%)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.payChargePerc),
      expression: "payChargePerc"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Pay Charge %')
    },
    attrs: {
      "type": "number",
      "name": "Pay Charge %",
      "id": "payChargePerc",
      "placeholder": "%"
    },
    domProps: {
      "value": (_vm.payChargePerc)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payChargePerc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pay Charge %')),
      expression: "errors.has('Pay Charge %')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("% of Freight charge is required")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.showpercent == true) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), (_vm.showpercent == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Limits (FOD Charges) (INR)")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Min")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.minFodCharge),
      expression: "minFodCharge"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('minFodCharge')
    },
    attrs: {
      "type": "number",
      "name": "minFodCharge",
      "id": "minFodCharge",
      "placeholder": "Min"
    },
    domProps: {
      "value": (_vm.minFodCharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "keyup": _vm.checkMinMax,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minFodCharge = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.maxFodCharge && _vm.minMaxError) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.minMaxError))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Max")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        min_value: 0
      }),
      expression: "{min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.maxFodCharge),
      expression: "maxFodCharge"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('maxFodCharge')
    },
    attrs: {
      "type": "number",
      "name": "maxFodCharge",
      "id": "maxFodCharge",
      "placeholder": "Max"
    },
    domProps: {
      "value": (_vm.maxFodCharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "keyup": _vm.checkMinMax,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxFodCharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxFodCharge),
      expression: "maxFodCharge"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('verifyToFodCharge'),
      expression: "'verifyToFodCharge'"
    }],
    attrs: {
      "type": "hidden",
      "name": "validateMaxFodCharge"
    },
    domProps: {
      "value": (_vm.maxFodCharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxFodCharge = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('maxFodCharge')),
      expression: "errors.has('maxFodCharge')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("MinFodCharge cannot be greater than MaxFodCharge.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('validateMaxFodCharge')),
      expression: "errors.has('validateMaxFodCharge')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('validateMaxFodCharge')))])], 1)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Fuel Surcharge")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 0px",
      "margin-top": "0.7rem"
    }
  }, [_vm._v("Fuel Surcharge")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 0px",
      "margin-top": "0.7rem"
    }
  }, [_vm._v("=")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 0px",
      "margin-top": "0.7rem"
    }
  }, [_vm._v("Freight Charges")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 0px",
      "margin-top": "0.7rem"
    }
  }, [_vm._v("x")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Surcharge %")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 13px 6px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargePercentage),
      expression: "surchargePercentage"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Surcharge %')
    },
    attrs: {
      "type": "number",
      "name": "Surcharge %",
      "id": "surchargePercentage",
      "placeholder": "Surcharge %"
    },
    domProps: {
      "value": (_vm.surchargePercentage)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargePercentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Surcharge %')),
      expression: "errors.has('Surcharge %')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Surcharge % is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "14px 0px 0px 0px"
    }
  }, [_vm._v("/100")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck4"
    }
  }, [_vm._v("Diesel Price Hike")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "12px 0px 0px 0px"
    }
  }, [_vm._v("Diesel Rate (INR/Ltr) on agreement date (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "4px 0px 5px 13px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        min_value: 0
      }),
      expression: "{min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dieselRate),
      expression: "dieselRate"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('DieselRate')
    },
    attrs: {
      "type": "number",
      "name": "DieselRate",
      "id": "dieselRate",
      "placeholder": "Diesel Rate"
    },
    domProps: {
      "value": (_vm.dieselRate)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dieselRate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('DieselRate')),
      expression: "errors.has('DieselRate')"
    }],
    staticClass: "text-danger errormsg"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio",
    staticStyle: {
      "padding": "10px 0px 0px 0px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dieselhiketype),
      expression: "dieselhiketype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Diesel Hike Type",
      "value": "%"
    },
    domProps: {
      "checked": _vm._q(_vm.dieselhiketype, "%")
    },
    on: {
      "__c": function($event) {
        _vm.dieselhiketype = "%"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("%    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "padding": "10px 0px 0px 0px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dieselhiketype),
      expression: "dieselhiketype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Diesel Hike Type",
      "value": "INR"
    },
    domProps: {
      "checked": _vm._q(_vm.dieselhiketype, "INR")
    },
    on: {
      "__c": function($event) {
        _vm.dieselhiketype = "INR"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("INR")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Diesel Hike Type')),
      expression: "errors.has('Diesel Hike Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select diesel hike type.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "12px 0px 0px 0px"
    }
  }, [_vm._v("Select Location Basis for Reference Diesel Price")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "clearable": false,
      "name": "dieselreflocation",
      "multiple": false,
      "max-height": 200,
      "options": _vm.locationlistforDieselPrice,
      "placeholder": "Select Location",
      "append-to-body": true,
      "valueFormat": "label"
    },
    model: {
      value: (_vm.dieselreflocation),
      callback: function($$v) {
        _vm.dieselreflocation = $$v
      },
      expression: "dieselreflocation"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dieselreflocation')),
      expression: "errors.has('dieselreflocation')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select a Location Basis for Reference Diesel Price.")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    }
  }, [_vm._v("Increase in Fuel Rate by")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dieselhiketype == 'INR'),
      expression: "dieselhiketype=='INR'"
    }],
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargeFuelUpRevisionPercent),
      expression: "surchargeFuelUpRevisionPercent"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('surchargeFuelUpRevisionPercent')
    },
    attrs: {
      "type": "number",
      "name": "surchargeFuelUpRevisionPercent",
      "id": "surchargeFuelUpRevisionPercent",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.surchargeFuelUpRevisionPercent)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargeFuelUpRevisionPercent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dieselhiketype == '%'),
      expression: "dieselhiketype=='%'"
    }],
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargeFuelUpRevisionPercent),
      expression: "surchargeFuelUpRevisionPercent"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('surchargeFuelUpRevisionPercent')
    },
    attrs: {
      "type": "number",
      "name": "surchargeFuelUpRevisionPercent",
      "id": "surchargeFuelUpRevisionPercent",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.surchargeFuelUpRevisionPercent)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargeFuelUpRevisionPercent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('surchargeFuelUpRevisionPercent')),
      expression: "errors.has('surchargeFuelUpRevisionPercent')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('surchargeFuelUpRevisionPercent')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "6px 12px"
    }
  }, [_vm._v("Increase in Base Rate by")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dieselhiketype == 'INR'),
      expression: "dieselhiketype=='INR'"
    }],
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargeFuelUpRevisionCharge),
      expression: "surchargeFuelUpRevisionCharge"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('surchargeFuelUpRevisionCharge')
    },
    attrs: {
      "type": "number",
      "name": "surchargeFuelUpRevisionCharge",
      "id": "surchargeFuelUpRevisionCharge",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.surchargeFuelUpRevisionCharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargeFuelUpRevisionCharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dieselhiketype == '%'),
      expression: "dieselhiketype=='%'"
    }],
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargeFuelUpRevisionCharge),
      expression: "surchargeFuelUpRevisionCharge"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('surchargeFuelUpRevisionCharge')
    },
    attrs: {
      "type": "number",
      "name": "surchargeFuelUpRevisionCharge",
      "id": "surchargeFuelUpRevisionCharge",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.surchargeFuelUpRevisionCharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargeFuelUpRevisionCharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('surchargeFuelUpRevisionCharge')),
      expression: "errors.has('surchargeFuelUpRevisionCharge')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('surchargeFuelUpRevisionCharge')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    }
  }, [_vm._v("Decrease in Fule Rate by")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dieselhiketype == 'INR'),
      expression: "dieselhiketype=='INR'"
    }],
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargeFuelDownRevisionPercent),
      expression: "surchargeFuelDownRevisionPercent"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('surchargeFuelDownRevisionPercent')
    },
    attrs: {
      "type": "number",
      "name": "surchargeFuelDownRevisionPercent",
      "id": "surchargeFuelDownRevisionPercent",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.surchargeFuelDownRevisionPercent)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargeFuelDownRevisionPercent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dieselhiketype == '%'),
      expression: "dieselhiketype=='%'"
    }],
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargeFuelDownRevisionPercent),
      expression: "surchargeFuelDownRevisionPercent"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('surchargeFuelDownRevisionPercent')
    },
    attrs: {
      "type": "number",
      "name": "surchargeFuelDownRevisionPercent",
      "id": "surchargeFuelDownRevisionPercent",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.surchargeFuelDownRevisionPercent)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargeFuelDownRevisionPercent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('surchargeFuelDownRevisionPercent')),
      expression: "errors.has('surchargeFuelDownRevisionPercent')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('surchargeFuelDownRevisionPercent')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "6px 12px"
    }
  }, [_vm._v("Decrease in Base Rate by")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dieselhiketype == 'INR'),
      expression: "dieselhiketype=='INR'"
    }],
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargeFuelDownRevisionCharge),
      expression: "surchargeFuelDownRevisionCharge"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('surchargeFuelDownRevisionCharge')
    },
    attrs: {
      "type": "number",
      "name": "surchargeFuelDownRevisionCharge",
      "id": "surchargeFuelDownRevisionCharge",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.surchargeFuelDownRevisionCharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargeFuelDownRevisionCharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dieselhiketype == '%'),
      expression: "dieselhiketype=='%'"
    }],
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.surchargeFuelDownRevisionCharge),
      expression: "surchargeFuelDownRevisionCharge"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('surchargeFuelDownRevisionCharge')
    },
    attrs: {
      "type": "number",
      "name": "surchargeFuelDownRevisionCharge",
      "id": "surchargeFuelDownRevisionCharge",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.surchargeFuelDownRevisionCharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surchargeFuelDownRevisionCharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('surchargeFuelDownRevisionCharge')),
      expression: "errors.has('surchargeFuelDownRevisionCharge')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('surchargeFuelDownRevisionCharge')))])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck5"
    }
  }, [_vm._v("Delivery Attempts")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "8px 6px 0px 14px"
    }
  }, [_vm._v("Free delivery attempts")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 0px 14px"
    },
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0' && 'integer'),
      expression: "'min_value:0' && 'integer'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryAttempt),
      expression: "deliveryAttempt"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Delivery Attempts')
    },
    attrs: {
      "type": "number",
      "name": "Delivery Attempts",
      "id": "deliveryAttempt",
      "placeholder": "Delivery Attempts"
    },
    domProps: {
      "value": (_vm.deliveryAttempt)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryAttempt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Delivery Attempts')),
      expression: "errors.has('Delivery Attempts')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Delivery Attempts')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "8px 0px 10px 14px"
    }
  }, [_vm._v("Minimum cost per paid attempt per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 10px 14px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryattemptmincharge),
      expression: "deliveryattemptmincharge"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Min Attempts Cost')
    },
    attrs: {
      "type": "number",
      "name": "Min Attempts Cost",
      "id": "deliveryattemptmincharge",
      "placeholder": "Min Attempts Cost"
    },
    domProps: {
      "value": (_vm.deliveryattemptmincharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryattemptmincharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Min Attempts Cost')),
      expression: "errors.has('Min Attempts Cost')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Min Attempts Cost')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio",
    staticStyle: {
      "padding": "8px 0px 0px 14px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryattempttype),
      expression: "deliveryattempttype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.deliveryattempttype, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.deliveryattempttype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding": "8px 0px 0px 8px"
    }
  }, [_vm._v("Cost per paid attempt per kg (INR)")])]), _vm._v(" "), (_vm.deliveryattempttype == 1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.costPerDeliveryAttempt),
      expression: "costPerDeliveryAttempt"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Attempts Cost')
    },
    attrs: {
      "type": "number",
      "name": "Attempts Cost",
      "id": "costPerDeliveryAttempt",
      "placeholder": "Cost Per Kg"
    },
    domProps: {
      "value": (_vm.costPerDeliveryAttempt)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.costPerDeliveryAttempt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Attempts Cost')),
      expression: "errors.has('Attempts Cost')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Attempts Cost')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio",
    staticStyle: {
      "padding": "8px 0px 0px 14px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryattempttype),
      expression: "deliveryattempttype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.deliveryattempttype, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.deliveryattempttype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding": "8px 0px 0px 0px"
    }
  }, [_vm._v("Cost per paid attempt per box (INR)")])]), _vm._v(" "), (_vm.deliveryattempttype == 2) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.costPerDeliveryAttempt),
      expression: "costPerDeliveryAttempt"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Attempts Cost')
    },
    attrs: {
      "type": "number",
      "name": "Attempts Cost",
      "id": "costPerDeliveryAttempt",
      "placeholder": "Cost Per Box"
    },
    domProps: {
      "value": (_vm.costPerDeliveryAttempt)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.costPerDeliveryAttempt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Attempts Cost')),
      expression: "errors.has('Attempts Cost')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Attempts Cost')))])], 1) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[6]),
      expression: "accordianTab[6]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck6"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[6]) ? _vm._i(_vm.accordianTab[6], null) > -1 : (_vm.accordianTab[6])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(6)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[6],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[6] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[6] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 6, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck6"
    }
  }, [_vm._v("Storage Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Applicable:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.demurragechargesapplicable),
      expression: "demurragechargesapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "demurragechargesapplicable",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.demurragechargesapplicable, "Yes")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.demurragechargesapplicable = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 45px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.demurragechargesapplicable),
      expression: "demurragechargesapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "demurragechargesapplicable",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.demurragechargesapplicable, "No")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.demurragechargesapplicable = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.demurragechargesapplicable == 'Yes') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Free storage days"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(Day count from day of intimation to client)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0' && 'integer' && 'required'),
      expression: "'min_value:0' && 'integer' && 'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.freeStorageDays),
      expression: "freeStorageDays"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Free Storage Days')
    },
    attrs: {
      "type": "number",
      "name": "Free Storage Days",
      "id": "freeStorageDays",
      "placeholder": "Free Storage Days"
    },
    domProps: {
      "value": (_vm.freeStorageDays)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.freeStorageDays = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Free Storage Days')),
      expression: "errors.has('Free Storage Days')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Free Storage Days field is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.demurragecostperdaytype),
      expression: "demurragecostperdaytype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('demurragecostperdaytype')
    },
    attrs: {
      "type": "radio",
      "name": "demurragecostperdaytype",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.demurragecostperdaytype, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.demurragecostperdaytype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])]), _vm._v(" "), _c('label', [_vm._v("Cost per kg per day (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), (_vm.demurragecostperdaytype == 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.demurrageCost),
      expression: "demurrageCost"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Demurrage Cost')
    },
    attrs: {
      "type": "number",
      "name": "Demurrage Cost",
      "id": "demurrageCost",
      "placeholder": "Cost per kg per day"
    },
    domProps: {
      "value": (_vm.demurrageCost)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.demurrageCost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Demurrage Cost')),
      expression: "errors.has('Demurrage Cost')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Cost per kg per day field is required")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.demurragecostperdaytype),
      expression: "demurragecostperdaytype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('demurragecostperdaytype')
    },
    attrs: {
      "type": "radio",
      "name": "demurragecostperdaytype",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.demurragecostperdaytype, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.demurragecostperdaytype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])]), _vm._v(" "), _c('label', [_vm._v("Cost per box per day (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), (_vm.demurragecostperdaytype == 2) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.demurrageCost),
      expression: "demurrageCost"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Demurrage Cost')
    },
    attrs: {
      "type": "number",
      "name": "Demurrage Cost",
      "id": "demurrageCost",
      "placeholder": "Cost per box per day"
    },
    domProps: {
      "value": (_vm.demurrageCost)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.demurrageCost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Demurrage Cost')),
      expression: "errors.has('Demurrage Cost')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Cost per box per day field is required")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.demurragecostperdaytype),
      expression: "demurragecostperdaytype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('demurragecostperdaytype')
    },
    attrs: {
      "type": "radio",
      "name": "demurragecostperdaytype",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.demurragecostperdaytype, "3")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.demurragecostperdaytype = "3"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])]), _vm._v(" "), _c('label', [_vm._v("Cost per slot days (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), (_vm.demurragecostperdaytype == 3) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 1
      }),
      expression: "{required: true, min_value:1}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.demurrageslotsdays),
      expression: "demurrageslotsdays"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Demurrage Slot Days')
    },
    attrs: {
      "type": "number",
      "name": "Demurrage Slot Days",
      "id": "demurrageslotsdays",
      "placeholder": "Slot days"
    },
    domProps: {
      "value": (_vm.demurrageslotsdays)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.demurrageslotsdays = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Demurrage Slot Days')),
      expression: "errors.has('Demurrage Slot Days')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Demurrage Slot Days')))])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.demurragecostperdaytype == 3) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.demurrageCost),
      expression: "demurrageCost"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Demurrage Cost')
    },
    attrs: {
      "type": "number",
      "name": "Demurrage Cost",
      "id": "demurrageCost",
      "placeholder": "Cost per slot days"
    },
    domProps: {
      "value": (_vm.demurrageCost)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.demurrageCost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Demurrage Cost')),
      expression: "errors.has('Demurrage Cost')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Cost per box per day field is required")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('demurragecostperdaytype')),
      expression: "errors.has('demurragecostperdaytype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select demurrage cost type")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "padding": "10px 0px 0px 5px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    }
  }, [_vm._v("Cost per Docket per Day (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required: true, min_value:0}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.demurrageminimumcharges),
      expression: "demurrageminimumcharges"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Min Demurrage Cost')
    },
    attrs: {
      "type": "number",
      "name": "Min Demurrage Cost",
      "id": "demurrageminimumcharges",
      "placeholder": "Cost per Docket per Day"
    },
    domProps: {
      "value": (_vm.demurrageminimumcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.demurrageminimumcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Min Demurrage Cost')),
      expression: "errors.has('Min Demurrage Cost')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Cost per Docket per Day field is required")])], 1)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[7]),
      expression: "accordianTab[7]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck7"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[7]) ? _vm._i(_vm.accordianTab[7], null) > -1 : (_vm.accordianTab[7])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(7)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[7],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[7] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[7] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 7, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck7"
    }
  }, [_vm._v("Appointment/Different Vehicle Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "dropdown-box"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "active": _vm.isAppointmentLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isAppointmentLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Applicable:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryapplicable),
      expression: "vehicledeliveryapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliveryapplicable, "Yes")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliveryapplicable = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryapplicable),
      expression: "vehicledeliveryapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliveryapplicable, "No")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliveryapplicable = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.vehicledeliveryapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "vehicledeliveryratebasis"
    }
  }, [_vm._v("Rate Basis:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryratebasis),
      expression: "vehicledeliveryratebasis"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Weight",
      "value": "1",
      "name": "vehicledeliveryratebasis"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliveryratebasis, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliveryratebasis = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Weight"
    }
  }, [_vm._v("Weight (kg)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryratebasis),
      expression: "vehicledeliveryratebasis"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Quantity",
      "value": "2",
      "name": "vehicledeliveryratebasis"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliveryratebasis, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliveryratebasis = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Quantity (Number of boxes)")])])])])]) : _vm._e(), _vm._v(" "), (_vm.vehicledeliveryapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliverychargetype),
      expression: "vehicledeliverychargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Appointment Delivery Charge Type",
      "value": "FlatRate"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliverychargetype, "FlatRate")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliverychargetype = "FlatRate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "rateBasis"
    }
  }, [_vm._v("Flat Rate")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliverychargetype),
      expression: "vehicledeliverychargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Appointment Delivery Charge Type",
      "value": "SlabBased"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliverychargetype, "SlabBased")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliverychargetype = "SlabBased"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    },
    attrs: {
      "for": "rateBasis"
    }
  }, [_vm._v("Slab based")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliverychargetype),
      expression: "vehicledeliverychargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Appointment Delivery Charge Type",
      "value": "ApprovalBasis"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliverychargetype, "ApprovalBasis")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliverychargetype = "ApprovalBasis"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    },
    attrs: {
      "for": "rateBasis"
    }
  }, [_vm._v("Approval basis")])])])])]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Appointment Delivery Charge Type')),
      expression: "errors.has('Appointment Delivery Charge Type')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Appointment Delivery Charge Type')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.vehicledeliverychargetype == 'FlatRate' && _vm.vehicledeliveryapplicable == 'Yes') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.vehicledeliveryratebasis == 2 ? "Cost per box (INR)" : "Cost per kg (INR)"))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryperkgcost),
      expression: "vehicledeliveryperkgcost"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Appointment Delivery Cost",
      "id": "vehicledeliveryperkgcost",
      "placeholder": "Cost (INR)"
    },
    domProps: {
      "value": (_vm.vehicledeliveryperkgcost)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicledeliveryperkgcost = $event.target.value
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.vehicledeliverychargetype == 'SlabBased' && _vm.vehicledeliveryapplicable == 'Yes') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "vehicledeliveryslabtype"
    }
  }, [_vm._v("Slab Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryslabtype),
      expression: "vehicledeliveryslabtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Weight",
      "value": "1",
      "name": "Appointment Slab Type"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliveryslabtype, "1")
    },
    on: {
      "change": _vm.selectVehicleDeliverySlab,
      "__c": function($event) {
        _vm.vehicledeliveryslabtype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Weight"
    }
  }, [_vm._v("Weight (kg) ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryslabtype),
      expression: "vehicledeliveryslabtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Quantity",
      "value": "2",
      "name": "vehicledeliveryslabtype"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliveryslabtype, "2")
    },
    on: {
      "change": _vm.selectVehicleDeliverySlab,
      "__c": function($event) {
        _vm.vehicledeliveryslabtype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Quantity (Number of boxes)")])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Appointment Slab Type')),
      expression: "errors.has('Appointment Slab Type')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Appointment Slab Type')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('label', [_vm._v("Select a Slab:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "clearable": false,
      "name": "Slab",
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforVehicleDelivery,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.selectslab
    },
    model: {
      value: (_vm.slabid),
      callback: function($$v) {
        _vm.slabid = $$v
      },
      expression: "slabid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Slab')),
      expression: "errors.has('Slab')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select a Slab.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "20px 0px 0px 15px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "vehicledeliveryslabchargetype"
    }
  }, [_vm._v("Slab Charge Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryslabchargetype),
      expression: "vehicledeliveryslabchargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Appointment Slab Charge Type')
    },
    attrs: {
      "type": "radio",
      "id": "Incremental",
      "value": "1",
      "name": "Appointment Slab Charge Type"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliveryslabchargetype, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliveryslabchargetype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Incremental"
    }
  }, [_vm._v("Incremental ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryslabchargetype),
      expression: "vehicledeliveryslabchargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Appointment Slab Charge Type')
    },
    attrs: {
      "type": "radio",
      "id": "Absolute",
      "value": "2",
      "name": "Appointment Slab Charge Type"
    },
    domProps: {
      "checked": _vm._q(_vm.vehicledeliveryslabchargetype, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.vehicledeliveryslabchargetype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Absolute"
    }
  }, [_vm._v("Absolute")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "slabcharge"
    }
  }, [_vm._v("Note: For Incremental, the charges will be calculated for each Slab Break. For Absolute, the entire charges will be calculated for the Slab the AWB belongs to.")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Appointment Slab Charge Type')),
      expression: "errors.has('Appointment Slab Charge Type')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Appointment Slab Charge Type')))])]), _vm._v(" "), (_vm.slabid != '') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('h6', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.vehicledeliveryslabtype == 2 ? "Quantity (Number of boxes)" : "Weight (kg)"))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("From")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("To")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Cost per Docket")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.slabBreakupData), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.fromname))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.toname))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.costValue[index]),
        expression: "costValue[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("weightValue" + index))
      },
      staticStyle: {
        "width": "26%",
        "margin-top": "-15px",
        "line-height": "15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'weightValue')
      },
      domProps: {
        "value": (_vm.costValue[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.costValue, index, $event.target.value)
        }
      }
    })])])])
  }))]), _c('br')])]) : _vm._e()])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.vehicledeliveryapplicable == 'Yes') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "Minimum charge per docket"
    }
  }, [_vm._v("Minimum charge per docket (INR)")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicledeliveryminimumchargeperdocket),
      expression: "vehicledeliveryminimumchargeperdocket"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Minimum charge per docket",
      "id": "vehicledeliveryminimumchargeperdocket",
      "placeholder": "Min Charge Per Docket"
    },
    domProps: {
      "value": (_vm.vehicledeliveryminimumchargeperdocket)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicledeliveryminimumchargeperdocket = $event.target.value
      }
    }
  })])], 1) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[8]),
      expression: "accordianTab[8]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck8"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[8]) ? _vm._i(_vm.accordianTab[8], null) > -1 : (_vm.accordianTab[8])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(8)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[8],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[8] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[8] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 8, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck8"
    }
  }, [_vm._v("Mathadi/ Varai Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', [_vm._v("Flat rate per box (MPS) (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required : true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mathadichargesperbox),
      expression: "mathadichargesperbox"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Mathadi Varai Charges')
    },
    attrs: {
      "type": "number",
      "name": "Mathadi Varai Charges",
      "id": "mathadichargesperbox",
      "placeholder": "Flat rate per box (MPS)"
    },
    domProps: {
      "value": (_vm.mathadichargesperbox)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mathadichargesperbox = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Mathadi Varai Charges')),
      expression: "errors.has('Mathadi Varai Charges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Flat rate per box (MPS) is required")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[9]),
      expression: "accordianTab[9]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck9"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[9]) ? _vm._i(_vm.accordianTab[9], null) > -1 : (_vm.accordianTab[9])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(9)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[9],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[9] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[9] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 9, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck9"
    }
  }, [_vm._v("Handling Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "active": _vm.isHandlingLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isHandlingLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Applicable:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handlingchargesapplicable),
      expression: "handlingchargesapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.handlingchargesapplicable, "Yes")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.handlingchargesapplicable = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handlingchargesapplicable),
      expression: "handlingchargesapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.handlingchargesapplicable, "No")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.handlingchargesapplicable = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.handlingchargesapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("Max Limits for no handling charges")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Physical weight (Kg)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.handlingChargePhysicalWeight),
      expression: "handlingChargePhysicalWeight"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Physical Weight",
      "id": "handlingChargePhysicalWeight",
      "placeholder": "Physical weight"
    },
    domProps: {
      "value": (_vm.handlingChargePhysicalWeight)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.handlingChargePhysicalWeight = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Physical Weight')),
      expression: "errors.has('Physical Weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Physical Weight is required.")]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Dimensions (cm)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("L")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.handlingLength),
      expression: "handlingLength"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Handling Length",
      "id": "handlingLength",
      "placeholder": "L"
    },
    domProps: {
      "value": (_vm.handlingLength)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.handlingLength = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("B")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.handlingBreadth),
      expression: "handlingBreadth"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Handling Breadth",
      "id": "handlingBreadth",
      "placeholder": "B"
    },
    domProps: {
      "value": (_vm.handlingBreadth)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.handlingBreadth = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("H")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.handlingHeight),
      expression: "handlingHeight"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Handling Height",
      "id": "handlingHeight",
      "placeholder": "H"
    },
    domProps: {
      "value": (_vm.handlingHeight)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.handlingHeight = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Handling Breadth') || _vm.errors.has('Handling Length') || _vm.errors.has('Handling Height')),
      expression: "errors.has('Handling Breadth') || errors.has('Handling Length') ||errors.has('Handling Height')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Dimensions are required")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("Over Weight Charges")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateType),
      expression: "rateType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Rate Type",
      "value": "FLAT"
    },
    domProps: {
      "checked": _vm._q(_vm.rateType, "FLAT")
    },
    on: {
      "__c": function($event) {
        _vm.rateType = "FLAT"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Flat Rate")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateType),
      expression: "rateType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Rate Type",
      "value": "SLAB"
    },
    domProps: {
      "checked": _vm._q(_vm.rateType, "SLAB")
    },
    on: {
      "__c": function($event) {
        _vm.rateType = "SLAB"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Slab Rate")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Rate Type')),
      expression: "errors.has('Rate Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select rate type.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.rateType == 'FLAT') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Per Kg over max limit (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.overweightcharges),
      expression: "overweightcharges"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Over weight Charges",
      "id": "overweightcharges",
      "placeholder": "Per Kg over max limit"
    },
    domProps: {
      "value": (_vm.overweightcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.overweightcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Over weight Charges')),
      expression: "errors.has('Over weight Charges')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Over weight Charges is required.")]), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.rateType == 'SLAB') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Choose a Slab")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "clearable": false,
      "name": "HandlingSlab",
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforOWC,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.selectshandlinglab
    },
    model: {
      value: (_vm.handlingslabid),
      callback: function($$v) {
        _vm.handlingslabid = $$v
      },
      expression: "handlingslabid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HandlingSlab')),
      expression: "errors.has('HandlingSlab')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please choose Slab.")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.handlingslabid != '' && _vm.rateType == 'SLAB') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("From")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("To")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Cost per kg (INR) (Per overweight MPS)")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.handlingslabBreakupData), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.fromname))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.toname))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.handlingcostValue[index]),
        expression: "handlingcostValue[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("handlingweightValue" + index))
      },
      staticStyle: {
        "width": "28%",
        "margin-top": "-17px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'handlingweightValue')
      },
      domProps: {
        "value": (_vm.handlingcostValue[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.handlingcostValue, index, $event.target.value)
        }
      }
    })])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.handlingslabid != '' && _vm.rateType == 'SLAB') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticStyle: {
      "padding": "8px 0px 0px 0px"
    }
  }, [_vm._v("Mechanical handling charges (forklift/crane) on actuals for weight above (kg)"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mechanicalhandlingcharges),
      expression: "mechanicalhandlingcharges"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Mechanical handling Charges",
      "id": "mechanicalhandlingcharges",
      "placeholder": "Weight (kg)"
    },
    domProps: {
      "value": (_vm.mechanicalhandlingcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mechanicalhandlingcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Mechanical handling Charges')),
      expression: "errors.has('Mechanical handling Charges')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Mechanical handling Charges is required.")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('strong', [_vm._v("Over Dimension Charges")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Dedicated vehicle cost at agreed rates")])])])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[10]),
      expression: "accordianTab[10]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck10"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[10]) ? _vm._i(_vm.accordianTab[10], null) > -1 : (_vm.accordianTab[10])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(10)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[10],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[10] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[10] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 10, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck10"
    }
  }, [_vm._v("Delivery Above Ground Level")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Applicable:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delievryabovegroundlevelapplicable),
      expression: "delievryabovegroundlevelapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.delievryabovegroundlevelapplicable, "Yes")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.delievryabovegroundlevelapplicable = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delievryabovegroundlevelapplicable),
      expression: "delievryabovegroundlevelapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.delievryabovegroundlevelapplicable, "No")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.delievryabovegroundlevelapplicable = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.delievryabovegroundlevelapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Max level above ground for no extra charge")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrow-circle-o-up'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required : true}"
    }],
    attrs: {
      "clearable": false,
      "name": "Above Ground Charges",
      "multiple": false,
      "max-height": 200,
      "options": _vm.floorOptions,
      "placeholder": "Select floor",
      "append-to-body": true,
      "disabled": false
    },
    model: {
      value: (_vm.MaxLevelAboveGroundCharges),
      callback: function($$v) {
        _vm.MaxLevelAboveGroundCharges = $$v
      },
      expression: "MaxLevelAboveGroundCharges"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Above Ground Charges')),
      expression: "errors.has('Above Ground Charges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select a floor")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.delievryabovegroundlevelapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Extra charges for delivery above max level defined")]), _c('br'), _vm._v(" "), (_vm.delievryabovegroundlevelapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("INR per kg per floor")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required : true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.AboveMaxLevelDefinedPerKg),
      expression: "AboveMaxLevelDefinedPerKg"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ExtraChargesPerKg')
    },
    attrs: {
      "type": "number",
      "name": "ExtraChargesPerKg",
      "id": "AboveMaxLevelDefinedPerKg",
      "placeholder": "INR per kg per floor"
    },
    domProps: {
      "value": (_vm.AboveMaxLevelDefinedPerKg)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AboveMaxLevelDefinedPerKg = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ExtraChargesPerKg')),
      expression: "errors.has('ExtraChargesPerKg')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("INR per kg per floor is required")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.delievryabovegroundlevelapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("INR per box per floor")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required : true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.AboveMaxLevelDefinedPerBox),
      expression: "AboveMaxLevelDefinedPerBox"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ExtraChargesPerBox')
    },
    attrs: {
      "type": "number",
      "name": "ExtraChargesPerBox",
      "id": "AboveMaxLevelDefinedPerBox",
      "placeholder": "INR per box per floor"
    },
    domProps: {
      "value": (_vm.AboveMaxLevelDefinedPerBox)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AboveMaxLevelDefinedPerBox = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ExtraChargesPerBox')),
      expression: "errors.has('ExtraChargesPerBox')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("INR per box per floor is required")])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('delievryabovegroundlevelchargetype')),
      expression: "errors.has('delievryabovegroundlevelchargetype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select charge type")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 0px 10px 18px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#3ba9f3"
    }
  }, [_vm._v("In case of availability of service/cargo lift, these charges will not be applicable.")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[11]),
      expression: "accordianTab[11]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck11"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[11]) ? _vm._i(_vm.accordianTab[11], null) > -1 : (_vm.accordianTab[11])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(11)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[11],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[11] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[11] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 11, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck11"
    }
  }, [_vm._v("Green Tax (For Delhi Inbound shipments only)")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', [_vm._v("Cost per kg (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required : true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.docketCost),
      expression: "docketCost"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Cost per kg per docket')
    },
    attrs: {
      "type": "number",
      "name": "Cost per kg per docket",
      "id": "docketCost",
      "placeholder": "Cost per kg"
    },
    domProps: {
      "value": (_vm.docketCost)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.docketCost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Cost per kg per docket')),
      expression: "errors.has('Cost per kg per docket')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Cost per kg per docket is required")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', [_vm._v("Cost per docket (INR)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required : true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.docketCostPerDocket),
      expression: "docketCostPerDocket"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Cost per docket')
    },
    attrs: {
      "type": "number",
      "name": "Cost per docket",
      "id": "docketCostPerDocket",
      "placeholder": "Cost per docket"
    },
    domProps: {
      "value": (_vm.docketCostPerDocket)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.docketCostPerDocket = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Cost per docket')),
      expression: "errors.has('Cost per docket')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Cost per docket is required")])], 1)]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[12]),
      expression: "accordianTab[12]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck12"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[12]) ? _vm._i(_vm.accordianTab[12], null) > -1 : (_vm.accordianTab[12])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(12)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[12],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[12] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[12] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 12, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck12"
    }
  }, [_vm._v("RTO Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtocharge),
      expression: "rtocharge"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required : true}"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "name": "RTO Charge",
      "id": "rtocharge",
      "placeholder": "INR per rate basis"
    },
    domProps: {
      "value": (_vm.rtocharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rtocharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RTO Charge')),
      expression: "errors.has('RTO Charge')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("RTO Charge is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("INR per rate basis " + _vm._s(_vm.ratebasis == 1 ? ' (per kg/per docket)' : ' (per box)') + " in addition to contract rates applicable for destination"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[13]),
      expression: "accordianTab[13]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck13"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[13]) ? _vm._i(_vm.accordianTab[13], null) > -1 : (_vm.accordianTab[13])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(13)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[13],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[13] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[13] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 13, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck13"
    }
  }, [_vm._v("ODA Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "oda-dropdown-box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Applicable for Pickup:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargesapplicable),
      expression: "pickupodachargesapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargesapplicable, "Yes")
    },
    on: {
      "click": function($event) {
        _vm.checkflagIdenticalRate()
      },
      "__c": function($event) {
        _vm.pickupodachargesapplicable = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargesapplicable),
      expression: "pickupodachargesapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargesapplicable, "No")
    },
    on: {
      "click": function($event) {
        _vm.checkflagIdenticalRate()
      },
      "__c": function($event) {
        _vm.pickupodachargesapplicable = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.pickupodachargesapplicable == 'Yes') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "pickupodachargeratebasis"
    }
  }, [_vm._v("Rate Basis:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargeratebasis),
      expression: "pickupodachargeratebasis"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "pickupWeight",
      "value": "1",
      "name": "pickupodachargeratebasis"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargeratebasis, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.pickupodachargeratebasis = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "pickupWeight"
    }
  }, [_vm._v("Weight (kg)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargeratebasis),
      expression: "pickupodachargeratebasis"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "pickupQuantity",
      "value": "2",
      "name": "pickupodachargeratebasis"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargeratebasis, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.pickupodachargeratebasis = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "pickupQuantity"
    }
  }, [_vm._v("Quantity (Number of boxes)")])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickupodachargeratebasis')),
      expression: "errors.has('pickupodachargeratebasis')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Rate Basis")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Rate Type:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargetype),
      expression: "pickupodachargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "pickupodachargetype",
      "value": "FlatRate"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargetype, "FlatRate")
    },
    on: {
      "click": function($event) {
        _vm.pickupresetOdaArray()
      },
      "__c": function($event) {
        _vm.pickupodachargetype = "FlatRate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Flat Rate")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargetype),
      expression: "pickupodachargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "pickupodachargetype",
      "value": "SlabRate"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargetype, "SlabRate")
    },
    on: {
      "click": function($event) {
        _vm.pickupresetOdaArray()
      },
      "__c": function($event) {
        _vm.pickupodachargetype = "SlabRate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Slab Rate")])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickupodachargetype')),
      expression: "errors.has('pickupodachargetype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Rate Type")]), _vm._v(" "), _c('b-card', [(_vm.pickupodachargetype == 'SlabRate') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "pickupodachargeslabtype"
    }
  }, [_vm._v("Slab Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargeslabtype),
      expression: "pickupodachargeslabtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "pickupWeight",
      "value": "1",
      "name": "pickupodachargeslabtype"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargeslabtype, "1")
    },
    on: {
      "change": function($event) {
        _vm.pickupselectOdaSlabDropdown()
      },
      "__c": function($event) {
        _vm.pickupodachargeslabtype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "pickupWeight"
    }
  }, [_vm._v("Weight (kg) ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargeslabtype),
      expression: "pickupodachargeslabtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "pickupQuantity",
      "value": "2",
      "name": "pickupodachargeslabtype"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargeslabtype, "2")
    },
    on: {
      "change": _vm.pickupselectOdaSlabDropdown,
      "__c": function($event) {
        _vm.pickupodachargeslabtype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "pickupQuantity"
    }
  }, [_vm._v("Quantity (Number of boxes)")])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickupodachargeslabtype')),
      expression: "errors.has('pickupodachargeslabtype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Slab Type")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "pickupodachargeslabchargetype"
    }
  }, [_vm._v("Slab Charge Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargeslabchargetype),
      expression: "pickupodachargeslabchargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "pickupWeight",
      "value": "1",
      "name": "pickupodachargeslabchargetype"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargeslabchargetype, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.pickupodachargeslabchargetype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "pickupWeight"
    }
  }, [_vm._v("Incremental ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargeslabchargetype),
      expression: "pickupodachargeslabchargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "pickupQuantity",
      "value": "2",
      "name": "pickupodachargeslabchargetype"
    },
    domProps: {
      "checked": _vm._q(_vm.pickupodachargeslabchargetype, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.pickupodachargeslabchargetype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "pickupQuantity"
    }
  }, [_vm._v("Absolute")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "pickupslabcharge"
    }
  }, [_vm._v("Note: For Incremental, the charges will be calculated for each Slab Break. For Absolute, the entire charges will be calculated for the Slab the AWB belongs to.")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickupodachargeslabchargetype')),
      expression: "errors.has('pickupodachargeslabchargetype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Slab Charge Type")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "10px 0px 0px 0px"
    }
  }, [_vm._v("Minimum cost per docket"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 10px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodachargesminimum),
      expression: "pickupodachargesminimum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Pickup Min Cost per docket",
      "id": "pickupodachargesminimum",
      "placeholder": "Min cost per docket"
    },
    domProps: {
      "value": (_vm.pickupodachargesminimum)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupodachargesminimum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pickup Min Cost per docket')),
      expression: "errors.has('Pickup Min Cost per docket')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Min Cost per docket is required")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodaAccoordian[1]),
      expression: "pickupodaAccoordian[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.pickupodatab,
      "id": "pickupoda1"
    },
    domProps: {
      "checked": Array.isArray(_vm.pickupodaAccoordian[1]) ? _vm._i(_vm.pickupodaAccoordian[1], null) > -1 : (_vm.pickupodaAccoordian[1])
    },
    on: {
      "click": function($event) {
        _vm.pickupodaToggle(1)
      },
      "__c": function($event) {
        var $$a = _vm.pickupodaAccoordian[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pickupodaAccoordian[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.pickupodaAccoordian[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.pickupodaAccoordian, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "pickupoda1"
    }
  }, [_vm._v("ODA 1 Charges"), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "padding": "0px 70% 0px 0px"
    }
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.pickupodachargetype == 'FlatRate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per kg (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodacostvalue1[0]),
      expression: "pickupodacostvalue1[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "pickupodacharge1",
      "placeholder": "Rate"
    },
    domProps: {
      "value": (_vm.pickupodacostvalue1[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pickupodacostvalue1, 0, $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodacostvalue12[0]),
      expression: "pickupodacostvalue12[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "pickupodacharge12",
      "placeholder": "Rate"
    },
    domProps: {
      "value": (_vm.pickupodacostvalue12[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pickupodacostvalue12, 0, $event.target.value)
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.pickupodachargetype == 'SlabRate') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Slab:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforODA,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.pickupselectOdaSlab1
    },
    model: {
      value: (_vm.pickupodaslabid1),
      callback: function($$v) {
        _vm.pickupodaslabid1 = $$v
      },
      expression: "pickupodaslabid1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "10px 0px 10px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Slab Break")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Rate per basis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pickupodaslabbreakupdata1), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.pickupodacostvalue1[index]),
        expression: "pickupodacostvalue1[index]"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("pickupodacostvalue1" + index))
      },
      staticStyle: {
        "width": "40%",
        "margin-top": "-15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'pickupodacostvalue1')
      },
      domProps: {
        "value": (_vm.pickupodacostvalue1[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.pickupodacostvalue1, index, $event.target.value)
        }
      }
    })])])
  }))])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodaAccoordian[2]),
      expression: "pickupodaAccoordian[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.pickupodatab,
      "id": "pickupoda2"
    },
    domProps: {
      "checked": Array.isArray(_vm.pickupodaAccoordian[2]) ? _vm._i(_vm.pickupodaAccoordian[2], null) > -1 : (_vm.pickupodaAccoordian[2])
    },
    on: {
      "click": function($event) {
        _vm.pickupodaToggle(2)
      },
      "__c": function($event) {
        var $$a = _vm.pickupodaAccoordian[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pickupodaAccoordian[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.pickupodaAccoordian[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.pickupodaAccoordian, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "pickupoda2"
    }
  }, [_vm._v("ODA 2 Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.pickupodachargetype == 'FlatRate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per kg (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodacostvalue2[0]),
      expression: "pickupodacostvalue2[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "pickupodacharge2",
      "placeholder": "Rate"
    },
    domProps: {
      "value": (_vm.pickupodacostvalue2[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pickupodacostvalue2, 0, $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodacostvalue22[0]),
      expression: "pickupodacostvalue22[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "pickupodacharge22",
      "placeholder": "Rate"
    },
    domProps: {
      "value": (_vm.pickupodacostvalue22[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pickupodacostvalue22, 0, $event.target.value)
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.pickupodachargetype == 'SlabRate') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Slab:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforODA,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.pickupselectOdaSlab2
    },
    model: {
      value: (_vm.pickupodaslabid2),
      callback: function($$v) {
        _vm.pickupodaslabid2 = $$v
      },
      expression: "pickupodaslabid2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "10px 0px 10px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Slab Break")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Rate per basis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pickupodaslabbreakupdata2), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.pickupodacostvalue2[index]),
        expression: "pickupodacostvalue2[index]"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("pickupodacostvalue2" + index))
      },
      staticStyle: {
        "width": "40%",
        "margin-top": "-15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'pickupodacostvalue2')
      },
      domProps: {
        "value": (_vm.pickupodacostvalue2[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.pickupodacostvalue2, index, $event.target.value)
        }
      }
    })])])
  }))])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodaAccoordian[3]),
      expression: "pickupodaAccoordian[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.pickupodatab,
      "id": "pickupoda3"
    },
    domProps: {
      "checked": Array.isArray(_vm.pickupodaAccoordian[3]) ? _vm._i(_vm.pickupodaAccoordian[3], null) > -1 : (_vm.pickupodaAccoordian[3])
    },
    on: {
      "click": function($event) {
        _vm.pickupodaToggle(3)
      },
      "__c": function($event) {
        var $$a = _vm.pickupodaAccoordian[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pickupodaAccoordian[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.pickupodaAccoordian[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.pickupodaAccoordian, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "pickupoda3"
    }
  }, [_vm._v("ODA 3 Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.pickupodachargetype == 'FlatRate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per kg (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodacostvalue3[0]),
      expression: "pickupodacostvalue3[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "pickupodacharge3",
      "placeholder": "Rate"
    },
    domProps: {
      "value": (_vm.pickupodacostvalue3[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pickupodacostvalue3, 0, $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodacostvalue32[0]),
      expression: "pickupodacostvalue32[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "pickupodacharge32",
      "placeholder": "Rate"
    },
    domProps: {
      "value": (_vm.pickupodacostvalue32[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pickupodacostvalue32, 0, $event.target.value)
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.pickupodachargetype == 'SlabRate') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Slab:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforODA,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.pickupselectOdaSlab3
    },
    model: {
      value: (_vm.pickupodaslabid3),
      callback: function($$v) {
        _vm.pickupodaslabid3 = $$v
      },
      expression: "pickupodaslabid3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "10px 0px 10px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Slab Break")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Rate per basis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pickupodaslabbreakupdata3), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.pickupodacostvalue3[index]),
        expression: "pickupodacostvalue3[index]"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("pickupodacostvalue3" + index))
      },
      staticStyle: {
        "width": "40%",
        "margin-top": "-15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'pickupodacostvalue3')
      },
      domProps: {
        "value": (_vm.pickupodacostvalue3[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.pickupodacostvalue3, index, $event.target.value)
        }
      }
    })])])
  }))])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodaAccoordian[4]),
      expression: "pickupodaAccoordian[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.pickupodatab,
      "id": "pickupoda4"
    },
    domProps: {
      "checked": Array.isArray(_vm.pickupodaAccoordian[4]) ? _vm._i(_vm.pickupodaAccoordian[4], null) > -1 : (_vm.pickupodaAccoordian[4])
    },
    on: {
      "click": function($event) {
        _vm.pickupodaToggle(4)
      },
      "__c": function($event) {
        var $$a = _vm.pickupodaAccoordian[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pickupodaAccoordian[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.pickupodaAccoordian[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.pickupodaAccoordian, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "pickupoda4"
    }
  }, [_vm._v("Special Pin Code Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.pickupodachargetype == 'FlatRate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per kg (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodacostvalue4[0]),
      expression: "pickupodacostvalue4[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "pickupodacharge",
      "placeholder": "Rate"
    },
    domProps: {
      "value": (_vm.pickupodacostvalue4[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pickupodacostvalue4, 0, $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupodacostvalue42[0]),
      expression: "pickupodacostvalue42[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "pickupodacharge42",
      "placeholder": "Rate"
    },
    domProps: {
      "value": (_vm.pickupodacostvalue42[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pickupodacostvalue42, 0, $event.target.value)
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.pickupodachargetype == 'SlabRate') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Slab:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforODA,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.pickupselectOdaSlab4
    },
    model: {
      value: (_vm.pickupodaslabid4),
      callback: function($$v) {
        _vm.pickupodaslabid4 = $$v
      },
      expression: "pickupodaslabid4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "10px 0px 10px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Slab Break")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Rate per basis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pickupodaslabbreakupdata4), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.pickupodacostvalue4[index]),
        expression: "pickupodacostvalue4[index]"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("pickupodacostvalue4" + index))
      },
      staticStyle: {
        "width": "40%",
        "margin-top": "-15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'pickupodacostvalue4')
      },
      domProps: {
        "value": (_vm.pickupodacostvalue4[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.pickupodacostvalue4, index, $event.target.value)
        }
      }
    })])])
  }))])])])]) : _vm._e()])])])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Applicable for Delivery:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargesapplicable),
      expression: "odachargesapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.odachargesapplicable, "Yes")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.odachargesapplicable = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargesapplicable),
      expression: "odachargesapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.odachargesapplicable, "No")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.odachargesapplicable = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.odachargesapplicable == 'Yes') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Rates Identical to Pickup?")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isodadeliverychargesidenticaltopickup),
      expression: "isodadeliverychargesidenticaltopickup"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "Yes",
      "disabled": _vm.pickupodachargesapplicable == 'No'
    },
    domProps: {
      "checked": _vm._q(_vm.isodadeliverychargesidenticaltopickup, "Yes")
    },
    on: {
      "click": function($event) {
        _vm.copypickupODACharges()
      },
      "__c": function($event) {
        _vm.isodadeliverychargesidenticaltopickup = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isodadeliverychargesidenticaltopickup),
      expression: "isodadeliverychargesidenticaltopickup"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "No",
      "disabled": _vm.pickupodachargesapplicable == 'No'
    },
    domProps: {
      "checked": _vm._q(_vm.isodadeliverychargesidenticaltopickup, "No")
    },
    on: {
      "click": function($event) {
        _vm.copypickupODACharges()
      },
      "__c": function($event) {
        _vm.isodadeliverychargesidenticaltopickup = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "odachargeratebasis"
    }
  }, [_vm._v("Rate Basis:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargeratebasis),
      expression: "odachargeratebasis"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Weight",
      "value": "1",
      "name": "odachargeratebasis",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "checked": _vm._q(_vm.odachargeratebasis, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.odachargeratebasis = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Weight"
    }
  }, [_vm._v("Weight (kg)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargeratebasis),
      expression: "odachargeratebasis"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Quantity",
      "value": "2",
      "name": "odachargeratebasis",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "checked": _vm._q(_vm.odachargeratebasis, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.odachargeratebasis = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Quantity (Number of boxes)")])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('odachargeratebasis')),
      expression: "errors.has('odachargeratebasis')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Rate Basis")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Rate Type:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargetype),
      expression: "odachargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "odachargetype",
      "value": "FlatRate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "checked": _vm._q(_vm.odachargetype, "FlatRate")
    },
    on: {
      "click": function($event) {
        _vm.resetOdaArray()
      },
      "__c": function($event) {
        _vm.odachargetype = "FlatRate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Flat Rate")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargetype),
      expression: "odachargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "odachargetype",
      "value": "SlabRate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "checked": _vm._q(_vm.odachargetype, "SlabRate")
    },
    on: {
      "click": function($event) {
        _vm.resetOdaArray()
      },
      "__c": function($event) {
        _vm.odachargetype = "SlabRate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Slab Rate")])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('odachargetype')),
      expression: "errors.has('odachargetype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Rate Type")]), _vm._v(" "), _c('b-card', [(_vm.odachargetype == 'SlabRate') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "odachargeslabtype"
    }
  }, [_vm._v("Slab Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargeslabtype),
      expression: "odachargeslabtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Weight",
      "value": "1",
      "name": "odachargeslabtype",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "checked": _vm._q(_vm.odachargeslabtype, "1")
    },
    on: {
      "change": function($event) {
        _vm.selectOdaSlabDropdown()
      },
      "__c": function($event) {
        _vm.odachargeslabtype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Weight"
    }
  }, [_vm._v("Weight (kg) ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargeslabtype),
      expression: "odachargeslabtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Quantity",
      "value": "2",
      "name": "odachargeslabtype",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "checked": _vm._q(_vm.odachargeslabtype, "2")
    },
    on: {
      "change": _vm.selectOdaSlabDropdown,
      "__c": function($event) {
        _vm.odachargeslabtype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Quantity (Number of boxes)")])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('odachargeslabtype')),
      expression: "errors.has('odachargeslabtype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Slab Type")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "odachargeslabchargetype"
    }
  }, [_vm._v("Slab Charge Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargeslabchargetype),
      expression: "odachargeslabchargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Weight",
      "value": "1",
      "name": "odachargeslabchargetype",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "checked": _vm._q(_vm.odachargeslabchargetype, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.odachargeslabchargetype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Weight"
    }
  }, [_vm._v("Incremental ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargeslabchargetype),
      expression: "odachargeslabchargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Quantity",
      "value": "2",
      "name": "odachargeslabchargetype",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "checked": _vm._q(_vm.odachargeslabchargetype, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.odachargeslabchargetype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Absolute")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "slabcharge"
    }
  }, [_vm._v("Note: For Incremental, the charges will be calculated for each Slab Break. For Absolute, the entire charges will be calculated for the Slab the AWB belongs to.")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('odachargeslabchargetype')),
      expression: "errors.has('odachargeslabchargetype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Slab Charge Type")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "10px 0px 0px 0px"
    }
  }, [_vm._v("Minimum cost per docket"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 10px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odachargesminimum),
      expression: "odachargesminimum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Min Cost per docket",
      "id": "odachargesminimum",
      "placeholder": "Min cost per docket",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odachargesminimum)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.odachargesminimum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Min Cost per docket')),
      expression: "errors.has('Min Cost per docket')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Min Cost per docket is required")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odaAccoordian[1]),
      expression: "odaAccoordian[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.odatab,
      "id": "oda1"
    },
    domProps: {
      "checked": Array.isArray(_vm.odaAccoordian[1]) ? _vm._i(_vm.odaAccoordian[1], null) > -1 : (_vm.odaAccoordian[1])
    },
    on: {
      "click": function($event) {
        _vm.odaToggle(1)
      },
      "__c": function($event) {
        var $$a = _vm.odaAccoordian[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.odaAccoordian[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.odaAccoordian[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.odaAccoordian, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "oda1"
    }
  }, [_vm._v("ODA 1 Charges"), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "padding": "0px 70% 0px 0px"
    }
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.odachargetype == 'FlatRate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per kg (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacostvalue1[0]),
      expression: "odacostvalue1[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "odacharge1",
      "placeholder": "Rate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odacostvalue1[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.odacostvalue1, 0, $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacostvalue12[0]),
      expression: "odacostvalue12[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "odacharge12",
      "placeholder": "Rate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odacostvalue12[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.odacostvalue12, 0, $event.target.value)
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.odachargetype == 'SlabRate') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Slab:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforODA,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    on: {
      "select": _vm.selectOdaSlab1
    },
    model: {
      value: (_vm.odaslabid1),
      callback: function($$v) {
        _vm.odaslabid1 = $$v
      },
      expression: "odaslabid1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "10px 0px 10px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Slab Break")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Rate per basis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.odaslabbreakupdata1), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.odacostvalue1[index]),
        expression: "odacostvalue1[index]"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("odacostvalue1" + index))
      },
      staticStyle: {
        "width": "40%",
        "margin-top": "-15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'odacostvalue1'),
        "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
      },
      domProps: {
        "value": (_vm.odacostvalue1[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.odacostvalue1, index, $event.target.value)
        }
      }
    })])])
  }))])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odaAccoordian[2]),
      expression: "odaAccoordian[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.odatab,
      "id": "oda2"
    },
    domProps: {
      "checked": Array.isArray(_vm.odaAccoordian[2]) ? _vm._i(_vm.odaAccoordian[2], null) > -1 : (_vm.odaAccoordian[2])
    },
    on: {
      "click": function($event) {
        _vm.odaToggle(2)
      },
      "__c": function($event) {
        var $$a = _vm.odaAccoordian[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.odaAccoordian[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.odaAccoordian[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.odaAccoordian, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "oda2"
    }
  }, [_vm._v("ODA 2 Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.odachargetype == 'FlatRate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per kg (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacostvalue2[0]),
      expression: "odacostvalue2[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "odacharge2",
      "placeholder": "Rate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odacostvalue2[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.odacostvalue2, 0, $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacostvalue22[0]),
      expression: "odacostvalue22[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "odacharge22",
      "placeholder": "Rate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odacostvalue22[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.odacostvalue22, 0, $event.target.value)
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.odachargetype == 'SlabRate') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Slab:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforODA,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    on: {
      "select": _vm.selectOdaSlab2
    },
    model: {
      value: (_vm.odaslabid2),
      callback: function($$v) {
        _vm.odaslabid2 = $$v
      },
      expression: "odaslabid2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "10px 0px 10px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Slab Break")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Rate per basis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.odaslabbreakupdata2), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.odacostvalue2[index]),
        expression: "odacostvalue2[index]"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("odacostvalue2" + index))
      },
      staticStyle: {
        "width": "40%",
        "margin-top": "-15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'odacostvalue2'),
        "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
      },
      domProps: {
        "value": (_vm.odacostvalue2[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.odacostvalue2, index, $event.target.value)
        }
      }
    })])])
  }))])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odaAccoordian[3]),
      expression: "odaAccoordian[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.odatab,
      "id": "oda3"
    },
    domProps: {
      "checked": Array.isArray(_vm.odaAccoordian[3]) ? _vm._i(_vm.odaAccoordian[3], null) > -1 : (_vm.odaAccoordian[3])
    },
    on: {
      "click": function($event) {
        _vm.odaToggle(3)
      },
      "__c": function($event) {
        var $$a = _vm.odaAccoordian[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.odaAccoordian[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.odaAccoordian[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.odaAccoordian, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "oda3"
    }
  }, [_vm._v("ODA 3 Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.odachargetype == 'FlatRate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per kg (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacostvalue3[0]),
      expression: "odacostvalue3[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "odacharge3",
      "placeholder": "Rate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odacostvalue3[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.odacostvalue3, 0, $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacostvalue32[0]),
      expression: "odacostvalue32[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "odacharge32",
      "placeholder": "Rate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odacostvalue32[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.odacostvalue32, 0, $event.target.value)
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.odachargetype == 'SlabRate') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Slab:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforODA,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    on: {
      "select": _vm.selectOdaSlab3
    },
    model: {
      value: (_vm.odaslabid3),
      callback: function($$v) {
        _vm.odaslabid3 = $$v
      },
      expression: "odaslabid3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "10px 0px 10px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Slab Break")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Rate per basis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.odaslabbreakupdata3), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.odacostvalue3[index]),
        expression: "odacostvalue3[index]"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("odacostvalue3" + index))
      },
      staticStyle: {
        "width": "40%",
        "margin-top": "-15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'odacostvalue3'),
        "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
      },
      domProps: {
        "value": (_vm.odacostvalue3[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.odacostvalue3, index, $event.target.value)
        }
      }
    })])])
  }))])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odaAccoordian[4]),
      expression: "odaAccoordian[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.odatab,
      "id": "oda4"
    },
    domProps: {
      "checked": Array.isArray(_vm.odaAccoordian[4]) ? _vm._i(_vm.odaAccoordian[4], null) > -1 : (_vm.odaAccoordian[4])
    },
    on: {
      "click": function($event) {
        _vm.odaToggle(4)
      },
      "__c": function($event) {
        var $$a = _vm.odaAccoordian[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.odaAccoordian[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.odaAccoordian[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.odaAccoordian, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "oda4"
    }
  }, [_vm._v("Special Pin Code Charges")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.odachargetype == 'FlatRate') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per kg (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacostvalue4[0]),
      expression: "odacostvalue4[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "odacharge",
      "placeholder": "Rate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odacostvalue4[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.odacostvalue4, 0, $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_vm._v("Additional rate per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 8px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacostvalue42[0]),
      expression: "odacostvalue42[0]"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "number",
      "id": "odacharge42",
      "placeholder": "Rate",
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    domProps: {
      "value": (_vm.odacostvalue42[0])
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.odacostvalue42, 0, $event.target.value)
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.odachargetype == 'SlabRate') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select a Slab:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablistforODA,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
    },
    on: {
      "select": _vm.selectOdaSlab4
    },
    model: {
      value: (_vm.odaslabid4),
      callback: function($$v) {
        _vm.odaslabid4 = $$v
      },
      expression: "odaslabid4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "padding": "10px 0px 10px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Slab Break")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Rate per basis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.odaslabbreakupdata4), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(data.name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.odacostvalue4[index]),
        expression: "odacostvalue4[index]"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("odacostvalue4" + index))
      },
      staticStyle: {
        "width": "40%",
        "margin-top": "-15px"
      },
      attrs: {
        "type": "number",
        "name": _vm.setname(index, 'odacostvalue4'),
        "disabled": _vm.isodadeliverychargesidenticaltopickup == 'Yes'
      },
      domProps: {
        "value": (_vm.odacostvalue4[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.odacostvalue4, index, $event.target.value)
        }
      }
    })])])
  }))])])])]) : _vm._e()])])])])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[14]),
      expression: "accordianTab[14]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck14"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[14]) ? _vm._i(_vm.accordianTab[14], null) > -1 : (_vm.accordianTab[14])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(14)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[14],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[14] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[14] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 14, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck14"
    }
  }, [_vm._v("Open Pickup/Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "opd-dropdown-box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    },
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Applicable:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openpickdeliveryapplicable),
      expression: "openpickdeliveryapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.openpickdeliveryapplicable, "Yes")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.openpickdeliveryapplicable = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openpickdeliveryapplicable),
      expression: "openpickdeliveryapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.openpickdeliveryapplicable, "No")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.openpickdeliveryapplicable = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.openpickdeliveryapplicable == 'Yes') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    }
  }, [_c('label', [_c('strong', [_vm._v("OPEN PICKUP DELIVERY")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openpickupdelivery),
      expression: "openpickupdelivery"
    }],
    attrs: {
      "type": "radio",
      "name": "openpickupdelivery",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.openpickupdelivery, "1")
    },
    on: {
      "click": function($event) {
        _vm.openpickdeliveryrateperitem = ''
      },
      "__c": function($event) {
        _vm.openpickupdelivery = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])]), _vm._v(" "), _c('label', [_vm._v("Rate per box per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openpickupdelivery),
      expression: "openpickupdelivery"
    }],
    attrs: {
      "type": "radio",
      "name": "openpickupdelivery",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.openpickupdelivery, "2")
    },
    on: {
      "click": function($event) {
        _vm.openpickdeliverycharges = ''
      },
      "__c": function($event) {
        _vm.openpickupdelivery = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])]), _vm._v(" "), _c('label', [_vm._v("Rate per Item within Child Shipment (INR)")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openpickdeliverycharges),
      expression: "openpickdeliverycharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.openpickdeliveryrateperitem ? false : true
        }
      }),
      expression: "{ rules: { required: openpickdeliveryrateperitem?false:true} }"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Rate per box (INR)",
      "id": "openpickdeliverycharges",
      "disabled": _vm.openpickupdelivery == 2,
      "placeholder": "Rate per box (INR)"
    },
    domProps: {
      "value": (_vm.openpickdeliverycharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openpickdeliverycharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Rate per box (INR)')),
      expression: "errors.has('Rate per box (INR)')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Rate per box (INR)')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "5px 0px 0px 14px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openpickdeliveryrateperitem),
      expression: "openpickdeliveryrateperitem"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.openpickdeliverycharges ? false : true
        }
      }),
      expression: "{ rules: { required: openpickdeliverycharges?false:true} }"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Rate per Item within Child Shipment (INR)",
      "id": "openpickdeliveryrateperitem",
      "disabled": _vm.openpickupdelivery == 1,
      "placeholder": "Rate per Item within Child Shipment (INR)"
    },
    domProps: {
      "value": (_vm.openpickdeliveryrateperitem)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openpickdeliveryrateperitem = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Rate per Item within Child Shipment (INR)')),
      expression: "errors.has('Rate per Item within Child Shipment (INR)')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Rate per Item within Child Shipment (INR)')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 0px 14px"
    }
  }, [_c('label', [_vm._v("Minimum cost per docket")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 10px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openpickdeliverychargesminimum),
      expression: "openpickdeliverychargesminimum"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "id": "openpickdeliverychargesminimum",
      "placeholder": "Min cost per docket"
    },
    domProps: {
      "value": (_vm.openpickdeliverychargesminimum)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openpickdeliverychargesminimum = $event.target.value
      }
    }
  })])], 1)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[15]),
      expression: "accordianTab[15]"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.accessorialTab,
      "id": "chck15"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[15]) ? _vm._i(_vm.accordianTab[15], null) > -1 : (_vm.accordianTab[15])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(15)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[15],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[15] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[15] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 15, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck15"
    }
  }, [_vm._v("Holiday Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "hd-dropdown-box"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Applicable:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaydeliverychargeapplicable),
      expression: "holidaydeliverychargeapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.holidaydeliverychargeapplicable, "Yes")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.holidaydeliverychargeapplicable = "Yes"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaydeliverychargeapplicable),
      expression: "holidaydeliverychargeapplicable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.holidaydeliverychargeapplicable, "No")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.holidaydeliverychargeapplicable = "No"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), (_vm.holidaydeliverychargeapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio",
    staticStyle: {
      "padding": "8px 0px 0px 14px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaydeliverychargestype),
      expression: "holidaydeliverychargestype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.holidaydeliverychargestype, "1")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.holidaydeliverychargestype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Rate per kg per docket (INR)")])]), _vm._v(" "), (_vm.holidaydeliverychargestype == 1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaydeliverycharges),
      expression: "holidaydeliverycharges"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "id": "holidaydeliverycharges",
      "placeholder": "Rate per kg"
    },
    domProps: {
      "value": (_vm.holidaydeliverycharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.holidaydeliverycharges = $event.target.value
      }
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio",
    staticStyle: {
      "padding": "8px 0px 0px 14px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaydeliverychargestype),
      expression: "holidaydeliverychargestype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.holidaydeliverychargestype, "2")
    },
    on: {
      "click": function($event) {},
      "__c": function($event) {
        _vm.holidaydeliverychargestype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Rate per box per docket (INR)")])]), _vm._v(" "), (_vm.holidaydeliverychargestype == 2) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaydeliverycharges),
      expression: "holidaydeliverycharges"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "id": "holidaydeliverycharges",
      "placeholder": "Rate per box"
    },
    domProps: {
      "value": (_vm.holidaydeliverycharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.holidaydeliverycharges = $event.target.value
      }
    }
  })])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.holidaydeliverychargeapplicable == 'Yes') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 0px 14px"
    }
  }, [_c('label', [_vm._v("Minimum cost per docket (INR)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    staticStyle: {
      "padding": "8px 0px 10px 14px"
    },
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaydeliverymincharges),
      expression: "holidaydeliverymincharges"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "id": "holidaydeliverymincharges",
      "placeholder": "Min cost per docket"
    },
    domProps: {
      "value": (_vm.holidaydeliverymincharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.holidaydeliverymincharges = $event.target.value
      }
    }
  })])], 1)]) : _vm._e()])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validateAndsaveAccessorialCharges
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v(" "), _c('br')])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb982bdc","hasScoped":true}!./src/modules/masterdata/views/ratetemplate/createratetemplate/accessorialcharges/accessorialcharges.component.html
// module id = 653
// module chunks = 3